import {clinicSqbOrderPay, getDicts, getMedicalOrderDetail} from "@/api";
import baseConfig from "@/api/config";
import {message} from "@/assets/utils/common";

export default {
    props: {
        orderId: ""
    },
    data() {
        return {
            userInfo: null,
            headImg: "",
            sysName: "",
            medicalOrder: {
                dppId: null, // 关联的病例ID
                docId: null, // 关联的医生ID
                docPatientCaseId: null, // 关联的病历ID
                conId: null,
                serialNo: null,
                docPrice: "0.00", //诊费
                clinicalDiagnosis: null, // 诊断结果
                medicineType: "0", //药剂类型
                billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
                orderMedicineList: [], // 关联药品
                remark: null, //备注
                patientPhone: null,
                patientName: null, // 患者姓名
                patientSex: null, // 患者性别
                patientAge: null,  // 患者年龄
                patientIdentity: null, // 患者身份证
                oldOrderId: null,
                linkDoctorInfo: null,
                hasLinkDoctor: false,
                takeWay: "0",
                viceNum: "7", //药品副数
                // docAdvice: '每日一副 分两次服用（开水冲化 温服）',  //医嘱
                docAdvice: '开水温服',
                orderWeight: "0", // 药材总重
                medicalCountPrice: "0.00", //药材费用
                processingCosts: "0.00", //加工费用
                orderPrice: "0.00", //总价
                instructions: null,
                smsPhone: "",
                adjustmentPrice: "0.00",// 调理价格
                discountPrice: "0.00", // 优惠金额
                freeCasePic: "", // 科研药方的图片
                isFree: "1",
                dayTakeNum: "1", //X日一剂
                takeTimes: "2", // 每日分X次服用/每日X次
                timeUseNum: "1", // 每次XX克、XX毫升
                packWay: "0", // 包装方式 （0袋装 1瓶装）
                useWay: null, // 医嘱用法
                useAttention: null, // 医嘱禁忌
                fuCountPrice: 0,  // 辅药药品费用
                decoctType: '0', // 煎煮方式  0=自煎,1=代煎
                specification: '200', // 煎煮规格 规格 200ml/180ml
                orderMedicineFuList: [],  //辅药列表（和药品列表一样传参）
                completeTime: "",
                cancelTime: "",
                payTime: "",
            },
            doctorInfo: {
                docPrice: null,
                docPriceRate: null,
                docPriceWay: 0,
                docFreeOpen: "",
                docPriceHide: "0",
            },
            dictOrderStatus: 'sys_order_status',
            dictOrderStatusList: [],

            prescriptionPaperDialogDialogVisible: false, // 处方笺预览弹窗
            printDate: null, // 打印日期
            payCodeList: [], // 预览的支付码
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            showOrderMedicineFuList: "",
            detailLoading: false,

            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部处方笺', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部处方笺', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: true, // 订单收费等待扫码
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            removeScanListener: null // 用于存储移除扫码监听器的函数
        }
    },

    created() {
        getDicts(this.dictOrderStatus).then(res => {
            this.dictOrderStatusList = res.data.data;
        });
        console.log("this.orderId");
        console.log(this.orderId);
        this.getMedicalOrderDetailInfo();
    },
    mounted() {
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.initScanListener();
    },
    // 在 beforeDestroy 钩子中清理事件监听器
    beforeDestroy() {
        // 如果存在移除监听器的函数，则调用它
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    methods: {
        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            console.log("orderId >>>>" + this.medicalOrder.orderId);
            console.log("orderPrice >>>>" + this.medicalOrder.orderPrice);
            console.log("dynamicId >>>>" + dynamicId);
            this.payLoading = true;
            this.isPayed = false;
            let params = {
                orderId: this.medicalOrder.orderId,
                price: this.medicalOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            console.log("this.isWaitPayLoading >>>>" + this.isWaitPayLoading);
            console.log("this.payLoading >>>>" + this.payLoading);
            console.log("this.isPayed >>>>" + this.isPayed);
            clinicSqbOrderPay(JSON.stringify(params)).then(response => {
                console.log(response);
                this.isWaitPayLoading = false;
                this.payLoading = false;
                this.isPayed = true;
                if (response.code === 200) {
                    message("支付成功", "success");
                    this.successPayed = true;
                } else {
                    this.successPayed = false;
                    message(response.msg || "支付失败", "error");
                }
                console.log("this.isWaitPayLoading >>>>" + this.isWaitPayLoading);
                console.log("this.payLoading >>>>" + this.payLoading);
                console.log("this.isPayed >>>>" + this.isPayed);
            }).catch(error => {
                console.error('支付请求失败:', error);
                message("支付请求失败", "error");
                this.payLoading = true;
            });
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },


        getOrderStatus(dictCode) {
            return this.getDictValue(dictCode, this.dictOrderStatusList);
        },

        getDictValue(dictKey, dictList) {
            let str = '';
            dictList.forEach(e => {
                if (e.dictValue == dictKey) {
                    str = e.dictLabel;
                }
            })
            return str;
        },

        // 获取订单详情信新
        getMedicalOrderDetailInfo() {
            console.log(this.orderId);
            this.detailLoading = true;
            getMedicalOrderDetail(this.orderId).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    this.detailLoading = false;
                    this.patientInfo = response.data.data.patientInfo;
                    if (this.patientInfo.sex === "1") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                    } else if (this.patientInfo.sex === "0") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                    } else {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                    }
                    this.doctorInfo = response.data.data.doctorInfo;
                    console.log("response.data.data.docPriceHide");
                    console.log(this.doctorInfo);
                    if (this.doctorInfo.docPrice === null || this.doctorInfo.docPrice === undefined || this.doctorInfo.docPrice === '') {
                        this.doctorInfo.docPrice = "0";
                    }
                    if (this.doctorInfo.docPriceRate === null || this.doctorInfo.docPriceRate === undefined || this.doctorInfo.docPriceRate === '') {
                        this.doctorInfo.docPriceRate = "0";
                    }
                    if (this.doctorInfo.docPriceHide === null || this.doctorInfo.docPriceHide === undefined || this.doctorInfo.docPriceHide === '') {
                        this.doctorInfo.docPriceHide = "0";
                    }
                    console.log(this.doctorInfo.docPriceHide);
                    this.medicalOrder = response.data.data.medicalOrder;
                    if (this.medicalOrder.docAdvice === null) {
                        this.medicalOrder.docAdvice = '每日一副 分两次服用（开水冲化 温服）';
                    }
                    if (this.medicalOrder.picUrl !== null && this.medicalOrder.picUrl !== "") {
                        this.medicalOrder.picUrl = this.tencentCosUrl + this.medicalOrder.picUrl;
                    }
                    this.payCodeList = [];
                    this.payCodeList.push(this.tencentCosUrl+this.medicalOrder.payQrcode);
                    if (this.medicalOrder.takeWay === "null" || this.medicalOrder.takeWay === null) {
                        this.medicalOrder.takeWay = "0";
                    }
                    if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === undefined || this
                        .medicalOrder.viceNum === "") {
                        this.medicalOrder.viceNum = "1";
                    }
                    this.indexMedicine = this.medicalOrder.billingType === null ? '0' : this.medicalOrder.billingType;
                    this.indexeat = parseInt(this.medicalOrder.takeWay === null ? '0' : this.medicalOrder.takeWay);
                    this.indexSex = parseInt(this.medicalOrder.patientSex === null ? '0' : this.medicalOrder.patientSex);

                    this.medicalOrder.packWay = this.medicalOrder.packWay === null ? '0' : this.medicalOrder.packWay;

                    this.medicalOrder.dayTakeNum = this.medicalOrder.dayTakeNum === null ? '1' : this.medicalOrder.dayTakeNum;//X日一剂
                    this.medicalOrder.takeTimes = this.medicalOrder.takeTimes === null ? '2' : this.medicalOrder.takeTimes;// 每日分X次服用/每日X次
                    this.medicalOrder.timeUseNum = this.medicalOrder.timeUseNum === null ? '1' : this.medicalOrder.timeUseNum;// 每次XX克、XX毫升

                    this.docMedicineArray = [];
                    var orderMedicineList = this.medicalOrder.orderMedicineList;
                    console.log("orderMedicineList");
                    console.log(orderMedicineList);
                    if (orderMedicineList !== null) {
                        orderMedicineList.forEach(melist => {
                            let decoctWay = melist.decoctWay;
                            let decoctionName = "";
                            if (decoctWay === '0') {
                                decoctionName = '无';
                            } else if (decoctWay === '1') {
                                decoctionName = '打碎';
                            } else if (decoctWay === '2') {
                                decoctionName = '烊化';
                            } else if (decoctWay === '3') {
                                decoctionName = '生汁兑入';
                            } else if (decoctWay === '4') {
                                decoctionName = '后下';
                            } else if (decoctWay === '5') {
                                decoctionName = '冲服';
                            }
                            melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            this.docMedicineArray.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                price: melist.medicinePrice,
                                gCount: melist.countNum,
                                meRemark: melist.meDesc,
                                mCount: melist.totalPrice,
                                decoctionId: decoctWay,
                                decoctionName: decoctionName,
                                drugProperty: melist.drugProperty
                            });
                        })
                    }

                    this.chooseFuliaoList = [];
                    var orderMedicineFuList = this.medicalOrder.orderMedicineFuList;
                    console.log("orderMedicineFuList");
                    console.log(orderMedicineFuList);
                    if (orderMedicineFuList !== null) {
                        orderMedicineFuList.forEach(melist => {
                            this.chooseFuliaoList.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                meDesc: melist.meDesc,
                                price: melist.price,
                                meCount: melist.countNum,
                                countPrice: melist.totalPrice
                            });
                        })
                    }

                    if (this.docMedicineArray.length > 0) {
                        this.docMedicineArray.forEach(docMedlist => {
                            docMedlist.decoctWay = docMedlist.decoctionId;
                        });
                        this.medicalOrder.orderMedicineList = this.docMedicineArray;
                    }
                    // this.reCount();
                } else {
                    message(response.data.msg, 'error');
                }
            });

        },


        // 订单收费
        openPayScreen() {
            this.orderPayDialogVisible = true;
            this.getMedicalOrderDetailInfo();
        },


        // 支付失败刷新重试
        cancalOrRefreshPay() {
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.getMedicalOrderDetailInfo();
        },


        // 打印待支付单据
        printPayInfo() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
        },


        // 取消支付
        cancalPay() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
        },


        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
